// import { TitleBar } from '@/services/Forms/Forms'
import { Checkbox_, Input_, Kotak, Select_, TitleBar } from '@/services/Forms/FormsSatu'
import { UploadOutlined } from '@ant-design/icons'
import { Button, Checkbox, Drawer, Form, Modal, Select } from 'antd'
import MainLayouts from 'layouts/MainLayouts'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Date_ } from 'services/Forms/Forms'
import { Button_, Switch_ } from 'services/Forms/FormsSatu'
import { msg } from 'services/Toastr/Notify/_Toastr'
import _Api from 'services/Api/_Api'
import InputMakananSehari from './InputMakananSehari'

function FormHidanganSehari(pr) {

    const [frm] = Form.useForm()
    const [combo, setcombo] = useState([])

    const init = () => {
        _Api.get("get-combo-hidangan-sehari").then(r => {
            setcombo(r.data)
        })
    }

    const KONSELING_ID = pr.konseling_id


    // <Col>  </Col>
    // <Col> </Col>
    // <Col>  </Col>
    // <Col>  </Col>
    // <Col>  </Col>
    // <Col>  </Col>

    const listRata2 = [
        { id: 1, label: "Rata-rata Sehari", name: "rata2sehari", sm: "2" },
        { id: 2, label: "Kalori", name: "energi", sm: "2" },
        { id: 3, label: "Protein", name: "protein", sm: "2", satuan: "gr" },
        { id: 4, label: "Karbo Hidrat", name: "kh", sm: "2", satuan: "gr" },
        { id: 5, label: "Kalsium", name: "kalsium", sm: "2", satuan: "gr" },
        { id: 6, label: "Zat Besi", name: "besi", sm: "2", satuan: "gr" },
        { id: 7, label: "Vit. A", name: "bkaroten", sm: "2", satuan: "gr" },
        { id: 8, label: "Vit. B1", name: "tiamin", sm: "2", satuan: "mg" },
        { id: 9, label: "Vit. C", name: "vitamin_c", sm: "2", satuan: "mg" },
    ]

    useEffect(() => {
        init()
        hitungTotal()
    }, [])

    const hitungTotal = () => {
        _Api.get("hitung-total-perkiraan?konseling_id=" + pr.konseling_id).then(g => {
            const formattedData = Object.fromEntries(
                Object.entries(g.data).map(([key, value]) => [key, value.toFixed(2)])
            );
            frm.setFieldsValue(formattedData)
        })
    }

    return (
        <div>

            <div className='mb-2'>
                <TitleBar title="Formulir Hidangan Sehari ( Recall 24 Jam ) sebelum sakit/sebelum dirawat" />
            </div>

            <Form form={frm} layout='vertical'>
                <Row>
                    {
                        listRata2.map((a, j, i) => (
                            <Input_ disabled label={a.label} sm={a.sm} name={a.name} addonAfter={a.satuan} />
                        ))
                    }
                </Row>

                <Button_ label="Hitung" onClick={hitungTotal} />
            </Form>

            <InputMakananSehari combo={combo} waktumakan="MAKAN PAGI" waktumakan_id="1" konseling_id={KONSELING_ID} />
            <InputMakananSehari combo={combo} waktumakan="MAKAN SIANG" waktumakan_id="2" konseling_id={KONSELING_ID} />
            <InputMakananSehari combo={combo} waktumakan="MAKAN MALAM" waktumakan_id="3" konseling_id={KONSELING_ID} />
            <br/>

        </div>

    )
}
export default FormHidanganSehari;

